(function () {
  'use strict';

  angular.module('app').component('checkInGuest', checkInGuest());

  function checkInGuest() {
    return {
      bindings: {
        item: '<',
        onSavedItem: '&',
        onCanceledItem: '&',
      },
      controller: CheckInGuestComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/bookings/booking-guests/check-in-guest/check-in-guest.component.html',
    };
  }

  CheckInGuestComponent.$inject = ['moment', 'GuestService', 'ModalWindowConfirmService'];

  function CheckInGuestComponent(moment, GuestService, ModalWindowConfirmService) {
    const vm = this;

    // private properties
    // -----------------------
    let notes = [];
    let modalParams = {
      confirmButtonLabel: 'YES',
      cancelButtonLabel: 'NO',
      preventModalClose: true,
      notes: null,
      body: null,
      title: null,
      showOnlyConfirmButton: null,
    };

    vm.$onInit = function () {
      vm.bookingItemServiceItem = vm.item.bookingItemServiceItem;
      vm.bookingItem = vm.item.bookingItem;

      vm.bookingItemName = vm.item.bookingItem.detail.name;
      vm.bookingItemServiceItemName = vm.bookingItem.based_on_service_items
        ? vm.item.bookingItemServiceItem.service_item.name
        : '';
      vm.isBaseOnServiceItem = vm.item.bookingItem.based_on_service_items;

      selectGuests(vm.item.booking.guests);
    };

    // public methods
    // -----------------------
    vm.setCheckInGuest = function (guest) {
      modalParams.notes = 'OPTIONAL_NOTES';
      modalParams.body = ' ';

      let successCallback = function (data) {
        guest.checkIn = guest.checkIn;
        vm.optionalNotes = data || '';

        addNotes(guest.id, vm.optionalNotes);
        validateCheckedGuests();
        saveCheckInBookingItem();
      };

      let cancelCallback = function () {
        guest.checkIn = !guest.checkIn;
      };

      if (guest.checkIn) {
        checkServiceDate(vm.bookingItem, successCallback, cancelCallback);
      } else {
        modalParams.title = 'ARE_YOU_SURE_TO_CHECK_OUT';

        ModalWindowConfirmService.open(modalParams, successCallback, cancelCallback);
      }
    };

    vm.checkInAllGuests = function () {
      let successCallback = (data) => {
        vm.optionalNotes = data;
        vm.guests.forEach((guest) => {
          if (moment().diff(moment(vm.bookingItem.start_date), 'days') >= 0) {
            guest.checkIn = vm.allGuestsChecked;
            addNotes(guest.id, vm.optionalNotes);
          }
        });

        validateCheckedGuests();
        saveCheckInBookingItem();
      };

      let cancelCallback = (data) => {
        vm.optionalNotes = data || '';
        vm.allGuestsChecked = !vm.allGuestsChecked;

        validateCheckedGuests();
      };

      modalParams.notes = 'OPTIONAL_NOTES';
      modalParams.body = vm.allGuestsChecked ? 'ARE_YOU_SURE_TO_CHECK_IN_ALL_ITEMS_BODY' : ' ';
      modalParams.title = vm.allGuestsChecked
        ? 'ARE_YOU_SURE_TO_CHECK_IN_ALL_ITEMS'
        : 'ARE_YOU_SURE_TO_CHECK_OUT_ALL_ITEMS';

      ModalWindowConfirmService.open(modalParams, successCallback, cancelCallback);
    };

    vm.cancel = function () {
      vm.onCanceledItem();
    };

    // private methods
    // -----------------------
    function selectGuests(guests) {
      vm.guests = [];
      guests.forEach((guest) => {
        if (vm.isBaseOnServiceItem) {
          vm.bookingItem.booking_item_service_items.forEach((serviceItem) => {
            if (guest.booking_item_service_item_ids.includes(serviceItem.id)) {
              guest.checkIn = guest.checked_in_service_items.includes(serviceItem.id);
              if (!vm.guests.includes(guest)) vm.guests.push(guest);
            }
          });
        } else if (guest.booking_item_ids.includes(vm.bookingItem.id)) {
          guest.checkIn = guest.checked_in_booking_items.includes(vm.bookingItem.id);
          vm.guests.push(guest);
        }
      });

      validateCheckedGuests();
    }

    function validateCheckedGuests() {
      vm.allGuestsChecked = vm.guests.every((guest) => guest.checkIn === true);

      vm.isBaseOnServiceItem ? checkInServiceItems() : checkInBookingItem(); // TODO: ??
    }

    function checkInServiceItems() {
      vm.guests.forEach((guest) => {
        let isServiceItemAdded = guest.checked_in_service_items.includes(
          vm.bookingItemServiceItem.id
        );
        if (guest.checkIn && !isServiceItemAdded) {
          guest.checked_in_service_items = guest.checked_in_service_items || [];
          guest.checked_in_service_items.push(vm.bookingItemServiceItem.id);
        } else {
          if (!guest.checkIn && isServiceItemAdded) {
            guest.checked_in_service_items.splice(
              guest.checked_in_service_items.map((id) => id).indexOf(vm.bookingItemServiceItem.id),
              1
            );
          }
        }
      });
    }

    function checkInBookingItem() {
      vm.guests.forEach((guest) => {
        let isBookingItemAdded = guest.checked_in_booking_items.includes(vm.bookingItem.id);
        if (guest.checkIn && !isBookingItemAdded) {
          guest.checked_in_booking_items = guest.checked_in_booking_items || [];
          guest.checked_in_booking_items.push(vm.bookingItem.id);
        } else {
          if (!guest.checkIn && isBookingItemAdded) {
            guest.checked_in_booking_items.splice(
              guest.checked_in_booking_items.map((id) => id).indexOf(vm.bookingItem.id),
              1
            );
          }
        }
      });
    }

    function checkServiceDate(bookingItem, successCallback, cancelCallback) {
      modalParams.notes = 'OPTIONAL_NOTES';
      modalParams.body = ' ';

      if (moment(bookingItem.start_date) < moment()) {
        modalParams.title = 'SELECTED_BOOKING_ITEMS_PAST';
      } else if (
        moment().diff(moment(bookingItem.start_date), 'days') < 2 &&
        moment().diff(moment(bookingItem.start_date), 'days') >= 0
      ) {
        modalParams.title = 'ARE_YOU_SURE_TO_CHECK_IN';
      } else {
        modalParams.title = 'CHECK_IN_IS_NOT_ALLOW';
        modalParams.confirmButtonLabel = 'ACCEPT';
        modalParams.showOnlyConfirmButton = true;

        delete modalParams.body;
        delete modalParams.notes;

        ModalWindowConfirmService.open(modalParams, cancelCallback);
        return;
      }

      ModalWindowConfirmService.open(modalParams, successCallback, cancelCallback);
    }

    function addNotes(id, note) {
      let index = notes
        .map((item) => {
          return item.id;
        })
        .indexOf(id);

      if (index < 0) {
        notes.push({ id: id, notes: note });
      } else {
        notes[index] = { id: id, notes: note };
      }
    }

    function saveCheckInBookingItem() {
      GuestService.saveCheckInBookingItem(vm.guests, notes, vm.bookingItem.booking_id).then(
        function (data) {
          vm.onSavedItem({ item: data.response });
        }
      );
    }
  }
})();
